import { MultiLineTextInput } from "dash-styled"
import { ChangeEvent, useState } from "react"

export const PromptInput = ({
    title,
    componentKey,
    groupKey,
    onChange,
    prompts,
    rows,
    isArray
}: {
    title: string
    componentKey: string
    groupKey: string
    onChange: (data: any) => void
    prompts: any
    rows: number
    isArray?: boolean
}) => {
    const [val, setVal] = useState(() => {
        const val = prompts?.[groupKey]?.[componentKey]
        return isArray ? (val ?? []).join("\n") : val ?? ""
    })
    return (
        <MultiLineTextInput
            className="mb-4"
            inputProps={{
                value: val,
                onChange: (e: ChangeEvent<HTMLTextAreaElement>) => {
                    setVal(e.target.value)
                    const value = isArray
                        ? e.target.value
                              .split("\n")
                              .filter(line => line.trim() !== "")
                        : e.target.value
                    onChange({
                        ...prompts,
                        [groupKey]: {
                            ...prompts?.[groupKey],
                            [componentKey]: value
                        }
                    })
                },
                rows
            }}
            variant="bordered"
            label={title}
        />
    )
}
